<script setup>
import {getCurrentInstance} from 'vue'
import {useAsyncState} from '@vueuse/core'
import FormControlTypeSelect from "../../common/form-control-type/FormControlTypeSelect.vue"

const props = defineProps({
    currentData: Object,
    field: Object,
    formId: String,
})

const {proxy} = getCurrentInstance()
const store = proxy.$store

/**
 * Fetch and process the event options
 * Replaces asyncComputed
 */
const {state: options} = useAsyncState(async () => {
    const tableName = 'odp_event'

    // 1. Get IDs
    const ids = await store.dispatch('itemIds/get', {tableName})

    // 2. Preload data
    const items = await store.dispatch('itemData/preload', {tableName, ids})

    // 3. Filter, Sort, and Map to the format FormControlTypeSelect expects
    return items
        .filter(o => o.isArchived === 0)
        .sort((a, b) => (a.displayOrder > b.displayOrder ? 1 : -1))
        .map(o => ({
            value: o.id,
            text: o.name
        }))
}, null) // Default to null so the v-if handles the loading state
</script>

<template>
    <FormControlTypeSelect v-if="options" :current-data="currentData" :field="field" :form-id="formId"
                           :options="options"/>
</template>